import { render, staticRenderFns } from "./burnoutChart.vue?vue&type=template&id=55c87d56&scoped=true&"
import script from "./burnoutChart.vue?vue&type=script&lang=js&"
export * from "./burnoutChart.vue?vue&type=script&lang=js&"
import style0 from "./burnoutChart.vue?vue&type=style&index=0&id=55c87d56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c87d56",
  null
  
)

export default component.exports